import { connect } from "react-redux";
import AppDownload from "./AppDownload";
import { getCountryCode } from "../../state/modules/regionalStore";

const mapStateToProps = state => ({
  countryCode: getCountryCode(state)
});

export default connect(mapStateToProps)(AppDownload);
